const Regexp = {
  ssn: /^[0-9]{12}$/,
  name: /^([\s\S]){2,128}$/,
  email:
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
};

export default Regexp;
